import React, { useEffect, useRef } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMapPin } = FiIcons;

// This is a simplified map overlay component
// In a real app, you would use a mapping library like Leaflet or Mapbox
const MapOverlay = ({ activity }) => {
  const canvasRef = useRef(null);
  
  useEffect(() => {
    if (!canvasRef.current) return;
    
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    
    // Set canvas size
    canvas.width = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;
    
    // Clear canvas
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    
    // In a real app, we would decode the polyline from activity.map.summary_polyline
    // For this demo, we'll draw a sample route
    drawDemoRoute(ctx, canvas.width, canvas.height);
    
    // Handle resize
    const handleResize = () => {
      if (canvas) {
        canvas.width = canvas.offsetWidth;
        canvas.height = canvas.offsetHeight;
        drawDemoRoute(ctx, canvas.width, canvas.height);
      }
    };
    
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [activity]);
  
  const drawDemoRoute = (ctx, width, height) => {
    // Create a simulated running route
    ctx.lineWidth = 3;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    
    // Create a gradient for the route
    const gradient = ctx.createLinearGradient(0, 0, width, height);
    gradient.addColorStop(0, '#ff6b35');
    gradient.addColorStop(0.5, '#f7931e');
    gradient.addColorStop(1, '#ff006e');
    ctx.strokeStyle = gradient;
    
    // Draw a route shape
    ctx.beginPath();
    
    // Starting point
    const startX = width * 0.2;
    const startY = height * 0.8;
    ctx.moveTo(startX, startY);
    
    // Generate a random-ish route
    // This is a simplification; real routes would use actual GPS coordinates
    ctx.bezierCurveTo(
      width * 0.3, height * 0.3,
      width * 0.5, height * 0.5,
      width * 0.6, height * 0.4
    );
    
    ctx.bezierCurveTo(
      width * 0.7, height * 0.3,
      width * 0.8, height * 0.6,
      width * 0.75, height * 0.7
    );
    
    ctx.bezierCurveTo(
      width * 0.7, height * 0.8,
      width * 0.5, height * 0.9,
      width * 0.2, height * 0.8
    );
    
    ctx.stroke();
    
    // Draw start marker
    ctx.fillStyle = '#4ade80';
    ctx.beginPath();
    ctx.arc(startX, startY, 6, 0, Math.PI * 2);
    ctx.fill();
    
    // Draw end marker
    ctx.fillStyle = '#f43f5e';
    ctx.beginPath();
    ctx.arc(width * 0.75, height * 0.7, 6, 0, Math.PI * 2);
    ctx.fill();
  };
  
  return (
    <div className="relative w-full h-full">
      <canvas 
        ref={canvasRef} 
        className="w-full h-full absolute inset-0"
      />
      <div className="absolute bottom-2 left-2 bg-black/50 text-white text-xs px-2 py-1 rounded flex items-center gap-1">
        <SafeIcon icon={FiMapPin} className="w-3 h-3 text-orange-400" />
        GPS Route
      </div>
    </div>
  );
};

export default MapOverlay;